import { connect } from 'react-redux';
import { Card, Row, Col } from 'react-bootstrap';
import BaseFeature from './BaseFeature';
import { SOFT_START } from '../../../../../../utils/constantFeatures';
import PropertySwitch from './components/PropertySwitch';
import PropertyPicker from './components/PropertyPicker';
import PropertyInfoTooltip from './components/PropertyInfoTooltip';
import { Trans } from 'react-i18next';

class SoftStart extends BaseFeature {

    constructor(props) {
        super(props);

        this.state = {
            isEnabled: this.props.properties[SOFT_START.enabled].value === "1",
        };

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(propertyName, value) {
        this.props.handleChange(propertyName, value);

        if (this.getCorrectPropertyName(propertyName) === SOFT_START.enabled) {
            this.setState({ isEnabled: value === "1" });
        }
    }

    render() {
        const sstEn = this.props.properties[SOFT_START.enabled];
        const sstT = this.props.properties[SOFT_START.time];
        const sstTLabel = 'Soft-start time';

        return (
            <><Row>
                <Col sm={3} style={{ minWidth: '400px' }}>
                    <Card className="card-feature-component" style={{ width: '100%' }}>
                        <div className="card-header-feature">
                            <Trans i18nKey="Soft_Start" />
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                            <PropertySwitch
                                property={sstEn}
                                title="Soft start time enable"
                                handleChange={this.handleChange} />
                            <PropertyPicker
                                disabled={!this.state.isEnabled}
                                property={sstT}
                                title={<>{sstTLabel}<PropertyInfoTooltip text={sstT.info.displayName} label={sstTLabel} /></>}
                                min={sstT.valueMeta.min}
                                max={sstT.valueMeta.max}
                                step={0.5}
                                measureUnit="s"
                                handleChange={this.handleChange}
                                inputStyle={{ padding: "0", maxWidth: "auto" }}
                                titleSize={9}
                                unitSize={1}
                                inputSize={2}
                                inputPadding={'padding-none'} />
                        </Card.Body>
                    </Card>
                </Col>
            </Row></>
        );
    }
}

export default connect()(SoftStart);
